import { _ } from "../polyglot/polyglot.js";
import dialog from "./dialog.js";

/**
 * `confirmationDialog` renders a modal confirmation dialog.
 *
 * `confirmationDialog` is rendered with a footer with two buttons, one to
 * confirm and one to cancel.
 *
 * It exposes two events: `onConfirm` and `onCancel`, triggered with no
 * value.
 *
 * @param {string} [spec.customConfirmClass] - Custom css class for
 * confirm label.
 * @param {Renderable} [spec.confirmLabel] - Label of the confirmation
 * button, 'Confirm' by default.
 * @param {Renderable} [spec.cancelLabel] - Label of the cancel button,
 * 'Cancel' by default.
 */
const confirmationDialog = dialog.subclass((that, my) => {
	my.initialize = function (spec) {
		my.super(spec);
		my.confirmLabel = spec.confirmLabel || _("Confirm");
		my.cancelLabel = spec.cancelLabel || _("Cancel");
		my.confirmClass = spec.customConfirmClass || "btn-primary";
	};

	that.onConfirm = my.events.createEvent();
	that.onCancel = my.events.createEvent();

	my.footerRenderOn = function (html) {
		html.div(
			{ klass: "modal-footer" },
			html
				.button(
					{
						klass: ["btn", my.confirmClass],
						"data-test": "confirm-button",
					},
					my.confirmLabel,
				)
				.click(() => {
					my.confirm();
				}),
			html
				.button(
					{ klass: "btn btn-default", "data-test": "cancel-button" },
					my.cancelLabel,
				)
				.click(() => {
					my.cancel();
				}),
		);
	};

	my.confirm = function () {
		that.hide();
		my.triggerConfirm();
	};

	my.triggerConfirm = function () {
		that.onConfirm.trigger();
	};

	my.cancel = function () {
		that.hide();
		that.onCancel.trigger();
	};
});

export default confirmationDialog;
